// eslint-disable-next-line strict
'use strict';
import axios from 'axios';
import { message } from 'antd';
import { AxiosConfig } from './basic';
import { qs } from '@gaodun.com/gtools';
const instance = axios.create();
instance.interceptors.request.use(
    async config => {
        return AxiosConfig.getStance().init(config);
    },
    error => {
        return Promise.reject(error);
    }
);
instance.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        return Promise.resolve(error.response);
    }
);

const checkStatus = (response: any) => {
    if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
        return response.data || {};
    }
    return { status: -404, message: '网络异常', result: null };
};

const checkCode = (resultData: { status: number; message?: string; info?: string; result?: any }): { result?: any; message?: string } => {
    const { status, result } = resultData;
    if (status === 0) {
        return { result };
    }
    message.destroy();
    message.error(resultData.message || resultData.info || '请求错误');
    return { message: resultData.message || resultData.info };
};

export default {
    post(url: string, data = {}) {
        return instance({
            method: 'post',
            url,
            data,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
        })
            .then(response => {
                return checkStatus(response);
            })
            .then(res => {
                return checkCode(res);
            });
    },
    get(url: string, params = {}) {
        return instance({
            method: 'get',
            url,
            params,
            timeout: 10000,
        })
            .then(response => {
                return checkStatus(response);
            })
            .then(res => {
                return checkCode(res);
            });
    },
    postForm(url: string, data = {}) {
        return instance({
            method: 'post',
            url,
            data: qs.stringify(data),
            timeout: 10000,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        })
            .then(response => {
                return checkStatus(response);
            })
            .then(res => {
                return res;
            });
    },
    upload(url: string, data = {}) {
        return instance({
            method: 'post',
            url,
            data,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
        })
            .then(response => {
                return checkStatus(response);
            })
            .then(res => {
                return checkCode(res);
            });
    },
};
